import LandingPage from "@/componets/LandingLayout";

const Blurex = () => {
  return <LandingPage page={"blurex-LP-V2"} />;
};

Blurex.hideLayout = true;
export default Blurex;
